export default __webpack_public_path__ + "static/media/EM1980.34I-43597_-26026_0.68d6d39b.jpg";